import atFlag from "./assets/flags/at.png";
import beFlag from "./assets/flags/be.png";
import czFlag from "./assets/flags/cz.png";
import deFlag from "./assets/flags/de.png";
import esFlag from "./assets/flags/es.png";
import frFlag from "./assets/flags/fr.png";
import enFlag from "./assets/flags/gb.png";
import itFlag from "./assets/flags/it.png";
import ltFlag from "./assets/flags/lt.png";
import nlFlag from "./assets/flags/nl.png";
import plFlag from "./assets/flags/pl.png";
import roFlag from "./assets/flags/ro.png";
import skFlag from "./assets/flags/sk.png";

export const defaultDomains = [
	"app.cargoseller.pl",
	"e30.stagetest.it",
	"app.cargo.local",
];

export const USER_ROLES = {
	user: "role_user", // translation key
	"branch-manager": "role_branch_manager", // translation key
	admin: "role_admin", // translation key
};
export const USER_ROLES_ARRAY = Object.keys(USER_ROLES);

export const GET_USER_ROLES_OPTIONS = (t) => {
	return Object.entries(USER_ROLES).map(([value, label]) => ({
		value,
		label: t(label),
	}));
};

export const supportedLanguages = [
	"at",
	"be",
	"cz",
	"de",
	"en",
	"es",
	"fr",
	"it",
	"lt",
	"nl",
	"pl",
	"ro",
	"sk",
];

export const phoneInputPreferredCountries = [
	"PL",
	"AT",
	"BE",
	"CZ",
	"DE",
	"GB",
	"ES",
	"FR",
	"IT",
	"LT",
	"NL",
	"RO",
	"SK",
];

export const phoneInputDefaultCountryDictionary = {
	at: "AT",
	be: "BE",
	cz: "CZ",
	de: "DE",
	en: "GB",
	es: "ES",
	fr: "FR",
	it: "IT",
	lt: "LT",
	nl: "NL",
	pl: "PL",
	ro: "RO",
	sk: "SK",
};

export const phoneInputLangOfCountriesDictionary = {
	at: "de",
	be: "nl",
	cz: "cs",
	de: "de",
	en: "en",
	es: "es",
	fr: "fr",
	it: "it",
	lt: "lt",
	nl: "nl",
	pl: "pl",
	ro: "ro",
	sk: "sk",
};

export const langDashCodesDictionary = {
	at: "de-AT",
	be: "nl-BE",
	cz: "cs-CZ",
	de: "de-DE",
	en: "en-GB",
	es: "es-ES",
	fr: "fr-FR",
	it: "it-IT",
	lt: "lt-LT",
	nl: "nl-NL",
	pl: "pl-PL",
	ro: "ro-RO",
	sk: "sk-SK",
};

export const langCountryCodesDictionary = {
	at: "de",
	be: "nl",
	cz: "cs",
	de: "de",
	en: "en",
	es: "es",
	fr: "fr",
	it: "it",
	lt: "lt",
	nl: "nl",
	pl: "pl",
	ro: "ro",
	sk: "sk",
};

export const lngs = {
	at: { nativeName: "Österreichisches", flagUrl: atFlag },
	be: { nativeName: "Nederlands (BE)", flagUrl: beFlag },
	cz: { nativeName: "Čeština", flagUrl: czFlag },
	de: { nativeName: "Deutsch", flagUrl: deFlag },
	en: { nativeName: "English", flagUrl: enFlag },
	es: { nativeName: "Español", flagUrl: esFlag },
	fr: { nativeName: "Français", flagUrl: frFlag },
	it: { nativeName: "Italiano", flagUrl: itFlag },
	lt: { nativeName: "Lietuvių", flagUrl: ltFlag },
	nl: { nativeName: "Nederlands (NL)", flagUrl: nlFlag },
	pl: { nativeName: "Polski", flagUrl: plFlag },
	ro: { nativeName: "Română", flagUrl: roFlag },
	sk: { nativeName: "Slovenčina", flagUrl: skFlag },
};
